(function () {
    // 注册组件
    SR.component.extend('like', like);
    
    function like() {
        var appcid = SR.util.urlParam('appcid');

        SR.dom.$body.on('click', '.J_like', function() {
            var $me = $(this);
            submit($me);
        });

        SR.dom.$body.on('click', '.J_dislike', function() {
            var $me = $(this);
            submit($me);
        });

        function submit($target) {
            var sceneType = $target.attr('data-type');
            var iCmd = $target.attr('data-icmd');
            var result = $target.attr('data-state');
            var q = $target.parents('.robot').prev('.me').find('.content').text();
            var isSubmitting = false;
            if (!iCmd || !q || result === undefined || isSubmitting || $target.hasClass('liked')) {
                return;
            }
            var data = {
                sceneType: sceneType,
                iCmd: iCmd,
                q: q,
                result: result
            }
            isSubmitting = true;
            $target.addClass('submitting');
            $.ajax({
                method: 'POST',
                timeout: SR.data.xhrTimeout,
                url: '/like?appcid=' + appcid,
                data: data,
            })
            .done(function(data) {
                if (data.ret === 0) {
                    if (result === '0') {
                        $target.addClass('liked');
                        $target.parents('.like-wrap').find('.dislike').fadeOut();
                    } else {
                        $target.parents('.like-wrap').find('.like').fadeOut(function() {
                            $target.parents('.like-wrap').find('.dislike').addClass('liked');
                        });
                    }
                } else {
                    SR.component.toast.show({msg: '提交失败，请重试'});
                }
            })
            .fail(function() {
                SR.component.toast.show({msg: '网络错误，请重试'});
            })
            .always(function() {
                isSubmitting = false;
                setTimeout(function() {
                    $target.removeClass('submitting');
                }, 1000);
            });
        }
    }
}());